// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606171403/js/" + chunkId + "." + {"44":"77262c7f","225":"617ecf4d","481":"ce93b31a","486":"a0ed2382","770":"5da82bbe"}[chunkId] + ".0.710311101254526.chunk.js";
};